<template>
  <div id="wrap-box" class="three-container" ref="threeContainer" :style="{ height: isSafari ? `${screenHeight}px` : '100vh'}" :class="{ 'three-container-wx': inWxEnv }"></div>
  <!-- Loading效果 -->
  <div v-if="isLoading" class="loading-container">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <div class="loading-text">加载中...</div>
    </div>
  </div>
  
  <button class="debug-button" :style="{ top: isSafari && isPortrait ? '50px' : '20px'}" @click="toggleDebug">
    {{ debugEnabled ? "关闭调试" : "打开调试" }}
  </button>

  <!-- 对话框 -->
  <div v-if="showDialog" class="dialog-container" :style="dialogPosition">
    <div class="dialog-box">
      <p class="dialog-text">{{ displayedText }}</p>
      <button
        class="purchase-button"
        @click="handleInteraction"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
  <div class="controls-guide" v-if="!isMobile">
    <div class="guide-title">操作指引</div>
    <div class="guide-item">
      <span class="key">W A S D</span>
      <span class="description">控制方向</span>
    </div>
    <div class="guide-item">
      <span class="key">SHIFT</span>
      <span class="description">切换跑步/走路</span>
    </div>
  </div>
  <!-- <SuccessDialog v-model:visible="show" message="支付成功" /> -->
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { MetaverseViewer } from "../infranstructure/viewers/metaverse/index.ts";
import { getScreenOrientation, isWeixin, loadWxJsSdk, checkIsSafari  } from "../utils/index.ts";
// 页面可见性监控变量
let lastHiddenTime = 0;
let visibilityTimeout = 10000; // 10秒

const threeContainer = ref(null);
let metaverse = null;
// const route = useRoute();
// console.log("route.query", route.query);
const modelUrl = ref('');
const debugEnabled = ref(false);
const interactionEnabled = ref(false);
const modelType = ref('');
const buttonText = ref('去看看');
const iosAreaHeight = 50;
const iosExtraHeight = 6;
const inWxEnv = ref(isWeixin());
// Loading状态
const isLoading = ref(true);
const screenHeight = ref(window.innerWidth < window.innerHeight ? screen.height + iosExtraHeight : window.innerHeight);
const isSafari = ref(checkIsSafari());
const isPortrait = ref(window.innerWidth < window.innerHeight);
let geometry = null;
let geometryPos = null;

// 对话框状态
const showDialog = ref(false);
let fullText = "先生~麦当劳大特惠，了解一下";
const displayedText = ref("");
const showPurchaseButton = ref(false);
const dialogPosition = ref(null);

let closeDialog = false;
let isInZoneOrigin = false;

// 文字动画相关变量
let textAnimationInterval = null;
let currentCharIndex = 0;

// 检测是否为移动设备
const isMobile = ref(true);

// 文字动画函数
const animateText = () => {
  if (currentCharIndex < fullText.length) {
    displayedText.value = fullText.substring(0, currentCharIndex + 1);
    currentCharIndex++;
  } else {
    clearInterval(textAnimationInterval);
    // 文字显示完毕后显示购买按钮
    // setTimeout(() => {
    //   showPurchaseButton.value = true;
    // }, 500);
  }
};

// 开始文字动画
const startTextAnimation = () => {
  // 重置状态
  currentCharIndex = 0;
  displayedText.value = "";
  showPurchaseButton.value = false;

  // 清除可能存在的旧定时器
  if (textAnimationInterval) {
    clearInterval(textAnimationInterval);
  }

  // 启动新的文字动画
  textAnimationInterval = setInterval(animateText, 100); // 每100毫秒显示一个字符
};

const initIeration = (isInZone, text, type, btnText) => {
  // metaverse.setInteractionCallback((isInZone, text, type) => {
    if (closeDialog && isInZone && isInZoneOrigin !== isInZone) return;
    if (isInZone === isInZoneOrigin) return;
    if (isInZone && !showDialog.value) {
      fullText = text;
      // 玩家进入区域，显示对话框
      showDialog.value = true;
      modelType.value = type;
      buttonText.value = btnText;
      // 开始文字动画
      startTextAnimation();
    } else if (!isInZone && showDialog.value) {
      // 玩家离开区域，隐藏对话框
      showDialog.value = false;
    }
    isInZoneOrigin = isInZone;
    closeDialog = false;
  // });
};

// 屏蔽长按操作的事件处理函数
const preventLongPress = (event) => {
  event.preventDefault();
  event.stopPropagation();
  return false;
};

// 监控页面可见性变化
const handleVisibilityChange = () => {
  if (document.hidden) {
    // 页面切到后台时保存位置
    console.log("页面切到后台，保存当前位置");
    if (metaverse && metaverse.playerController && metaverse.sceneController) {
      metaverse.playerController.saveCurrentPosition(
        metaverse.sceneController,
        "documentVisibility",
      );
    }
  } else {
    // 页面切回来时恢复位置
    console.log("页面切回前台，恢复保存的位置");
    setTimeout(() => {
      if (
        metaverse &&
        metaverse.playerController &&
        metaverse.sceneController
      ) {
        metaverse.playerController.restoreSavedPosition(
          metaverse.sceneController,
          "documentVisibility",
          true
        );
      }
    }, 200);
  }
};

// 组件挂载时初始化Metaverse
onMounted(async () => {
  handIsPortrait();
  await init();
  // 添加页面可见性变化监听器
  document.addEventListener("visibilitychange", handleVisibilityChange);
  // return;
  try {
    if (!modelUrl.value) return;
    metaverse = new MetaverseViewer(
      threeContainer.value,
      decodeURIComponent(modelUrl.value),
      {
        onInteractionCallback: initIeration.bind(this),
        onLoadingComplete: () => {
          isLoading.value = false;
        }
      }
    );
    await metaverse.init();
    // 初始化窗口控制器
    isMobile.value = metaverse.getIsMobile();
    metaverse.setDebugPanelVisible(debugEnabled.value);


    // 添加窗口大小调整监听器
    window.addEventListener("resize", onWindowResize);

    // 屏蔽长按操作事件监听器
    if (threeContainer.value) {
      // 禁用右键菜单
      threeContainer.value.addEventListener("contextmenu", preventLongPress);

      // 禁用长按选择
      threeContainer.value.addEventListener("selectstart", preventLongPress);

      // 禁用拖拽开始
      threeContainer.value.addEventListener("dragstart", preventLongPress);

      // 移动端长按事件处理
      let longPressTimer = null;

      threeContainer.value.addEventListener("touchstart", (e) => {
        longPressTimer = setTimeout(() => {
          e.preventDefault();
          e.stopPropagation();
        }, 500); // 500ms后触发长按阻止
      });

      threeContainer.value.addEventListener("touchend", () => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
      });

      threeContainer.value.addEventListener("touchmove", () => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
      });
    }
  } catch (error) {
    console.error("MetaverseViewer 初始化失败:", error);
  }
});

// 窗口大小调整处理
const onWindowResize = () => {
  handIsPortrait();
  if (metaverse) {
    metaverse.onWindowResize();
  }
};

// 组件卸载前清理资源
onBeforeUnmount(() => {
  if (metaverse) {
    metaverse.destroy();
  }

  // 移除页面可见性变化监听器
  document.removeEventListener("visibilitychange", handleVisibilityChange);
});
// 切换调试模式
const toggleDebug = () => {
  debugEnabled.value = !debugEnabled.value;
  if (metaverse) {
    metaverse.setDebugPanelVisible(debugEnabled.value);
    console.log("调试状态已切换为:", debugEnabled.value ? "开启" : "关闭");
  }
};

// 处理交互按钮点击
const handleInteraction = () => {
  console.log("交互按钮被点击", metaverse.playerController.getPosition(), 'modelType', modelType.value);

  window.wx.miniProgram.postMessage({
    data: {
      action: "pay",
      orderId: "12345",
      position: metaverse.playerController.getPosition(),
      modelType: modelType.value,
    },
  });

  console.log("wx.miniProgram.navigateTo");
  showDialog.value = false;
  closeDialog = true;

  wx.miniProgram.navigateTo({ url: `/pages/authorize/index?modelType=${modelType.value}` });
};

// 恢复保存的位置和视角信息
const restoreSavedPosition = () => {
  if (!metaverse || !metaverse.playerController || !metaverse.sceneController) {
    return;
  }

  metaverse.playerController.restoreSavedPosition(
    metaverse.sceneController,
    "default",
  );
};
const init = async () => {
  if(isWeixin()) {
    console.log('微信SDK:')
    loadWxJsSdk();
  }
  // 获取 hash 部分（去除 #）
  const hashString = window.location.href.split('#/viewer')[1];   // 或 window.location.hash.slice(1) 在实际页面上
  console.log('hashString1===', hashString);
  // 用 URLSearchParams 解析
  const params = new URLSearchParams(hashString);

  const sceneUrl = params.get('sceneUrl');
  console.log('sceneUrl====', sceneUrl);
  modelUrl.value = sceneUrl;
  // 初始化窗口控制器
  // const requestFile = await fetch(sceneUrl, {
  //   mode: 'cors',
  //   credentials: 'omit',
  //   cache: 'reload',
  // });
  // console.log(1111, requestFile);
  // if (requestFile.status !== 200) {
  //   return new Error(`load  error ${requestFile.statusText},${requestFile.body}`);
  // }
  // const content = await requestFile.json();
  // console.log('content==', content);
  // document.title = content.name;
  // if (content.interaction) {
  //   interactionEnabled.value = content.interaction.interaction;
  //   if (content.interaction.geometry && content.interaction.geometryPos) {
  //     geometry = content.interaction.geometry.split("|");
  //     geometryPos = content.interaction.geometryPos.split("|");
  //   }
  // }
};
const handIsPortrait = () => {
  if (inWxEnv.value || !isSafari.value) return;
  if (getScreenOrientation().isPortrait) {
    isPortrait.value = true;
    if (!isLoading.value) {
      metaverse.debugPanel.state.stats.dom.style.top = '50px';
    }
    // var el = document.getElementById('safeAreaProbe');
    // el ? el.offsetHeight : 0;
    screenHeight.value = screen.height + iosExtraHeight;
    // document.getElementById('wrap-box').scrollIntoView({
    //   block: 'end',
    //   behavior: 'instant'
    // });
    window.scrollTo(0, iosAreaHeight);
  } else {
    isPortrait.value = false;
    if (!isLoading.value) {
      metaverse.debugPanel.state.stats.dom.style.top = '0';
    }
    screenHeight.value = window.innerHeight;
    // window.scrollTo({ top: 0 });
    document.getElementById('wrap-box').scrollIntoView({
      block: 'end',
      behavior: 'instant'
    });
  }
}
</script>

<style scoped>
.three-container {
  width: 100vw;
  /* height: 100%; */
  /* height: 100vh; */
  /* overflow: hidden; */
  /* position: fixed; */
  /* top: 0;
  left: 0;
  right: 0;
  bottom: 0; */
  z-index: 1;
  /* 强制忽略所有安全区域 */
  padding: 0;
  margin: 0;

  /* 屏蔽长按操作 */
  -webkit-touch-callout: none; /* 禁用iOS长按弹出菜单 */
  -webkit-user-select: none; /* 禁用文本选择 */
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 禁用长按上下文菜单 */
  -webkit-context-menu: none;
  -moz-context-menu: none;

  /* 禁用拖拽 */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;

  /* 禁用高亮 */
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* 禁用长按保存图片等操作 */
  pointer-events: auto;
  touch-action: manipulation; /* 只允许滚动和缩放，禁用其他手势 */
}
.three-container-wx {
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
/* 移动端专用样式 - 真正的全屏 */
@media screen and (max-width: 768px) {
  .three-container {
    /* 使用负边距来覆盖安全区域 */
    margin-top: calc(-1 * env(safe-area-inset-top, 0px));
    margin-bottom: calc(-1 * env(safe-area-inset-bottom, 0px));
    margin-left: calc(-1 * env(safe-area-inset-left, 0px));
    margin-right: calc(-1 * env(safe-area-inset-right, 0px));

    /* 扩展尺寸来覆盖安全区域 */
    width: calc(
      100vw + env(safe-area-inset-left, 0px) + env(safe-area-inset-right, 0px)
    );
    height: calc(
      100vh + env(safe-area-inset-top, 0px) + env(safe-area-inset-bottom, 0px)
    );

    /* 防止页面滚动 */
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;

    /* 确保内容覆盖状态栏 */
    top: calc(-1 * env(safe-area-inset-top, 0px));
    left: calc(-1 * env(safe-area-inset-left, 0px));
  }
}

/* iPhone 专用全屏配置 */
@supports (-webkit-touch-callout: none) {
  @media screen and (max-width: 768px) {
    .three-container {
      /* iOS 设备强制全屏 */
      height: calc(
        100vh + env(safe-area-inset-top, 0px) + env(safe-area-inset-bottom, 0px)
      );
      width: calc(
        100vw + env(safe-area-inset-left, 0px) + env(safe-area-inset-right, 0px)
      );

      /* 使用 transform 来确保完全覆盖 */
      transform: translate(
        calc(-1 * env(safe-area-inset-left, 0px)),
        calc(-1 * env(safe-area-inset-top, 0px))
      );
    }
  }
}

/* 全局样式确保页面不会有滚动 */
@media screen and (max-width: 768px) {
  html,
  body {
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
}

.debug-button {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 100;
  font-size: 14px;
}

.debug-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.save-position-button {
  position: absolute;
  top: 20px;
  right: 120px;
  padding: 8px 16px;
  background-color: rgba(76, 175, 80, 0.8);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 100;
  font-size: 14px;
  transition: all 0.2s ease;
}

.save-position-button:hover {
  background-color: rgba(76, 175, 80, 1);
  transform: translateY(-1px);
}

.controls-guide {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 12px;
  border-radius: 4px;
  z-index: 100;
  font-size: 14px;
  min-width: 180px;
}

.guide-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 16px;
  text-align: center;
}

.guide-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.key {
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 3px;
  margin-right: 10px;
}

.description {
  flex-grow: 1;
  text-align: right;
}

.interaction-button {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 100;
}

.interaction-button:hover {
  background-color: #45a049;
  transform: translateX(-50%) scale(1.05);
}

.dialog-container {
  position: absolute;
  z-index: 100;
  pointer-events: none; /* Allow clicks to pass through to the scene */
  left: 50%;
  top: 9%;
  transform: translateX(-50%);
}

.dialog-box {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px;
  border-radius: 8px;
  max-width: 300px;
  min-height: 74px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  pointer-events: auto; /* Re-enable pointer events for the dialog box */
}

.dialog-text {
  margin: 0 0 15px 0;
  min-height: 23px;
  font-size: 16px;
  line-height: 1.4;
}

.purchase-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  display: block;
  margin: 0 auto;
}

.purchase-button:hover {
  background-color: #45a049;
  transform: scale(1.05);
}

/* Loading样式 */
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.loading-spinner {
  text-align: center;
  color: white;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 18px;
  font-weight: 500;
  color: white;
}

/* 移动端loading适配 */
@media screen and (max-width: 768px) {
  .loading-spinner {
    padding: 20px;
  }
  
  .loading-text {
    font-size: 16px;
  }
}
</style>
